import React, { useState, useEffect } from "react";
import { Button, Typography, Box, Grid } from "@mui/material";
import Success from "../../../ATS/images/confetti.gif";
import "../../css/preview.css";
import "../../css/style.css";
import { GetAtsAgreementMastersHelper } from "../../../ATS/helper/AtsAgreementHelper";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { s3Client } from "../../../Base/helper/baseFunctions";

const AgreementPreview = ({
  setCurrentMode,
  activeStep,
  setActiveStep,
  data,
  handleSave
}) => {
  const [step, setStep] = useState("1");
  const [headerImg, setHeaderImg] = useState("");
  const [footerImg, setFooterImg] = useState("");
  const [pages, setPages] = useState([]);

  const getImgUrl = async (val) => {
    if (!val) return "";
    if (val.startsWith("data:image/")) return val;
    try {
      const bucketParams = {
        Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
        Key: val,
      };
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      );
      return url;
    } catch (err) {
      console.error("Failed to get signed URL for image:", err);
      return "";
    }
  };

  useEffect(() => {
    GetAtsAgreementMastersHelper("header_image").then(async (res) => {
      if (res && !res.hasError && res.data?.data?.length > 0) {
        const rawVal = res.data.data[0].value_pct || res.data.data[0].value || "";
        const url = await getImgUrl(rawVal);
        setHeaderImg(url);
      }
    });
    GetAtsAgreementMastersHelper("footer_image").then(async (res) => {
      if (res && !res.hasError && res.data?.data?.length > 0) {
        const rawVal = res.data.data[0].value_pct || res.data.data[0].value || "";
        const url = await getImgUrl(rawVal);
        setFooterImg(url);
      }
    });
  }, []);
  useEffect(() => {
    if (!data?.template_content) return;

    const calculatePages = async () => {
        const getImgDimensions = (url) => {
            return new Promise((resolve) => {
                if (!url) return resolve({ width: 0, height: 0 });
                const img = new Image();
                img.onload = () => {
                    resolve({ width: img.naturalWidth, height: img.naturalHeight });
                };
                img.onerror = () => {
                    resolve({ width: 0, height: 0 });
                };
                img.src = url;
            });
        };

        const headerDim = await getImgDimensions(headerImg);
        const footerDim = await getImgDimensions(footerImg);

        const headerHeight = headerDim.width ? (headerDim.height / headerDim.width) * 674 : 0;
        const footerHeight = footerDim.width ? (footerDim.height / footerDim.width) * 674 : 0;

        // Total sheet height = 1123px. Padding = 60px top/bottom (120px total)
        // Spacing buffer = 16px (mb: 2 of header) + 16px (mt: 2 of footer) + 20px safe buffer = 52px
        const spacingBuffer = 52;
        const maxHeight = 1123 - 120 - headerHeight - footerHeight - spacingBuffer;

        const rawHtml = data.template_content.replace(/<!--FIELDS_JSON:(.*)-->/, "").trim();
        const parserDiv = document.createElement("div");
        parserDiv.innerHTML = rawHtml;
        const blocks = Array.from(parserDiv.childNodes).map(node => node.cloneNode(true));

        const testContainer = document.createElement("div");
        testContainer.className = "offer-preview-content-1 offer_customization";
        testContainer.style.position = "absolute";
        testContainer.style.visibility = "hidden";
        testContainer.style.width = "674px"; // 794px width - 120px padding (60px * 2)
        testContainer.style.fontFamily = "Candara, sans-serif";
        testContainer.style.fontSize = "11pt";
        testContainer.style.lineHeight = "1.5";
        document.body.appendChild(testContainer);

        const pagesList = [];
        let currentPageHtml = "";
        let currentHeight = 0;

        for (let block of blocks) {
            testContainer.appendChild(block);
            const blockHeight = block.offsetHeight || 30;
            
            if (currentHeight + blockHeight > maxHeight && currentPageHtml !== "") {
                pagesList.push(currentPageHtml);
                testContainer.innerHTML = "";
                testContainer.appendChild(block);
                currentPageHtml = block.outerHTML || block.textContent;
                currentHeight = blockHeight;
            } else {
                currentPageHtml += block.outerHTML || block.textContent;
                currentHeight += blockHeight;
            }
        }
        if (currentPageHtml) {
            pagesList.push(currentPageHtml);
        }

        document.body.removeChild(testContainer);
        setPages(pagesList);
    };

    calculatePages();
  }, [data, headerImg, footerImg]);
  const onSubmit = async () => {
    setStep("2");
    await handleSave();
    setTimeout(() => {
      setCurrentMode("grid");
    }, 3000);
  };

  return (
    <>
      {step === "1" ? (
        <>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography sx={{ mb: 2, textAlign: "center", fontWeight: 600 }} variant="h6">
              Agreement Template Preview
            </Typography>
          </Box>
          <Grid container direction="column" alignItems="center">
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3, width: "100%", alignItems: "center", bgcolor: "#f1f5f9", p: 3, borderRadius: "10px" }}>
              {pages.map((pageHtml, index) => (
                <div key={index} className="a4-page-sheet" style={{
                  width: "794px",
                  height: "1123px",
                  padding: "60px",
                  backgroundColor: "white",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  overflow: "hidden"
                }}>
                  {headerImg && (
                    <Box sx={{ width: "100%", mb: 2 }}>
                      <img src={headerImg} alt="Header" style={{ width: "100%", display: "block" }} />
                    </Box>
                  )}
                  <div style={{ flex: 1, overflow: "hidden" }} className="offer-preview-content-1 offer_customization" dangerouslySetInnerHTML={{ __html: pageHtml }} />
                  {footerImg && (
                    <Box sx={{ width: "100%", mt: 2 }}>
                      <img src={footerImg} alt="Footer" style={{ width: "100%", display: "block" }} />
                    </Box>
                  )}
                </div>
              ))}
            </Box>

            <Grid item xs={12} sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  padding: "0px 10px",
                  width: "100%"
                }}
              >
                <Button
                  variant="contained"
                  className="mpl-primary-btn"
                  onClick={() => setActiveStep(activeStep - 1)}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  className="mpl-primary-btn"
                  onClick={onSubmit}
                >
                  Complete Template
                </Button>
              </Box>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "#e6f4ea",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              padding: "20px",
              margin: "auto",
            }}
          >
            <img
              src={Success}
              alt="Success"
              width={"100px"}
              height={"100px"}
              style={{
                backgroundColor: "#fff",
                borderRadius: "50%",
                padding: "10px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            />
            <Typography sx={{ pt: 2, pb: 1, textAlign: "center", fontWeight: 600 }} variant="h5">
              Your Agreement Template is Created Successfully
            </Typography>
          </Box>
        </>
      )}
    </>
  );
};

export default AgreementPreview;
